import { ListItem, ListItemIcon, ListItemText, Stack, Typography } from "@mui/material";
import { useRest } from "../common/rest";
import { useCrusade } from "./crusade";
import { WCodexIcon } from "./wh.ui.icons";
import { GREY, SECONDARY_COLOR } from "../style/theme";


export function MvpList() {
    const crusade = useCrusade()
    const [mvps] = useRest('mvp/' + crusade.id + '/top')
    if (!mvps) {
        return <></>
    }
    const ret = []
    mvps.forEach((mvp, idx) => {
        const unit = mvp.unit;
        ret.push(<ListItem key={unit.id} sx={{
            marginY: 2,
            background: 'linear-gradient(90deg, #563234 0%, ' + GREY[100] + ' 100% )',
        }}>
            <Stack direction="row" alignItems="center" spacing={2}>
                <Typography variant="h5" color="secondary">
                    #{idx + 1}
                </Typography>
                <WCodexIcon name={mvp.playerCodex} />
                <Stack>
                    <Typography sx={{ fontSize: 12, lineHeight: 1.1, color: SECONDARY_COLOR }}>
                        {mvp.playerName}
                    </Typography>
                    <ListItemText
                        primary={unit.name || unit.unitType}
                        secondary={unit.name ? unit.unitType : ''}
                    />
                    <Typography sx={{ fontSize: 12, lineHeight: 1.2, color: GREY[800] }}>
                        Vittorie {unit.wins} / {unit.played}
                    </Typography>
                    <Typography sx={{ fontSize: 12, lineHeight: 1.2, color: GREY[800] }}>
                        Uccisioni {unit.kills}
                    </Typography>
                    <Typography sx={{ fontSize: 12 }}>
                        {unit.description}
                    </Typography>
                </Stack>
            </Stack>
        </ListItem>)
    });

    return <Stack>
        {ret}
    </Stack>
}